export default __webpack_public_path__ + "static/media/team-2.815c5ad4.jpg";